<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  overflow: scroll !important;
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
* {
  box-sizing: border-box;
  font-family: "_cn-regular", Arial, Helvetica, sans-serif;
}
*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  padding: 0;
}
#bsWXBox {
  box-sizing: content-box;
}
ul {
  list-style: none;
}
body,
div,
span,
h1,
h2,
h3,
h4,
h5,
h6,
p,
em,
img,
strong,
b,
small,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
sub,
sup,
tt,
var,
del,
dfn,
ins,
kbd,
q,
s,
samp,
strike,
applet,
object,
iframe,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
mark,
audio,
video,
input,
textarea,
select {
  margin: 0;
  padding: 0;
}
a:link,
a:visited {
  text-decoration: none;
  outline: 0;
  color: #666;
}
a:hover,
a:active,
a:focus {
  color: #666;
  text-decoration: none;
}
img {
  border: 0;
  padding: 0;
  margin: 0;
  max-width: 100%;
}
table {
  border-collapse: collapse;
  width: 100%;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}
input,
textarea {
  font-size: 14px;
  outline: 0;
  overflow: hidden;
  font-family: arial, "_cn-regular", Arial, Helvetica, sans-serif;
}
input[type="reset"],
input[type="button"],
input[type="submit"],
input[type="radio"] {
  cursor: pointer;
  outline: 0;
  border: none;
}
input[type="checkbox"],
input[type="radio"] {
  position: relative;
  vertical-align: middle;
}
textarea,
input[type="email"],
input[type="date"],
input[type="password"],
input[type="text"] {
  outline: 0;
  color: #666;
}
input[type="submit"],
input[type="reset"],
input[type="button"],
input[type="text"],
select,
button {
  -webkit-appearance: none;
}
input,
select,
textarea {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
::-webkit-input-placeholder {
  color: #999;
}
:-moz-placeholder {
  color: #999;
  opacity: 1;
}
::-moz-placeholder {
  color: #999;
  opacity: 1;
}
:-ms-input-placeholder {
  color: #999;
}
.clearfix:after {
  clear: both;
  height: 0;
  content: "";
  line-height: 0;
  font-size: 0;
  display: block;
}
.clear {
  clear: both;
}
#app {
  font-family: "SourceHanSansCN", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  /* text-align: center; */
}
.regular-text {
  color: #2B2B2B;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  hyphens: auto;
}
.regular-text.hyphens {
  /* 标准属性 */
  hyphens: auto;
  /* WebKit 浏览器 (Safari, Chrome) */
  -webkit-hyphens: auto;
  /* Firefox */
  -moz-hyphens: auto;
  /* IE 10+ */
  -ms-hyphens: auto;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: justify;
}
.common-paragraph-13 {
  font-size: 13px;
  text-indent: 26px;
  line-height: 2.6;
}
.common-paragraph-13.hyphens{
  /* 标准属性 */
  hyphens: auto;
  /* WebKit 浏览器 (Safari, Chrome) */
  -webkit-hyphens: auto;
  /* Firefox */
  -moz-hyphens: auto;
  /* IE 10+ */
  -ms-hyphens: auto;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: justify;
}
.common-image-900 {
  width: 900px;
  height: auto;
}
.content-block {
  width: 900px;
  margin: 0 auto;
}
.content-block.pd-tb-120 {
  padding: 120px 0;
}
.content-shape {
  width: 42px;
  height: 42px;
  background: linear-gradient(to bottom, #203267, #2547AC);
  clip-path: polygon(0 0, 0 100%, 100% 0);
}
.content-shape-1 {
  width: 42px;
  height: 42px;
  background: linear-gradient(to bottom, #2547AC, #203267);
  clip-path: polygon(0 100%, 100% 100%, 100% 0);
}  
.content-title {
  margin: 0 auto;
  margin-top: -35px;
  font-size: 32px;
  font-weight: 500;
  color: #2C2C2C;
  width: 80%;
  text-align: center;
  padding-bottom: 80px;
  line-height: 1.2;
}
.content-subtitle {
  color: #999;
  font-weight: 500;
  font-size: 15px;
  margin-bottom: 40px;
  line-height: 1.3;
  padding: 0 0;
  /* 标准属性 */
  hyphens: auto;
  /* WebKit 浏览器 (Safari, Chrome) */
  -webkit-hyphens: auto;
  /* Firefox */
  -moz-hyphens: auto;
  /* IE 10+ */
  -ms-hyphens: auto;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: justify;
}

.content-subtitle.black {
  color: #0F1010;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 25px;
}

.content-services {
  list-style-type: none;
  padding: 0 14px;
  /* 标准属性 */
  hyphens: auto;
  /* WebKit 浏览器 (Safari, Chrome) */
  -webkit-hyphens: auto;
  /* Firefox */
  -moz-hyphens: auto;
  /* IE 10+ */
  -ms-hyphens: auto;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: justify;
}

.content-services li {
  color: #2B2B2B;
  margin-bottom: 25px;
  font-size: 14px;
  position: relative;
  padding-left: 30px;
  font-weight: 500;
  line-height: 1.3;
}

.content-services.double-space li {
  margin-bottom: 36px;
}

.content-services.small-dot-padding li {
  padding-left: 20px;
}

.content-services li::before {
  content: "●";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  color: #2B2B2B;
  font-size: 8px;
}

.content-more {
  color: rgb(44, 54, 118);
  cursor: pointer;
}

.content-product-images {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}

.content-product-images img {
  max-width: 30%;
  width: auto;
}

.content-product-information {
  margin-bottom: 60px;
}

.probe-station-product-image {
  width: 850px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 100px;
}
.probe-station-product-image-table {
  width: 900px;
  height: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue